<div *ngIf="privilegesView==='AccessDenied'" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div *ngIf="privilegesView==='AccessDenied'" class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>


<div *ngIf="privilegesView==='VAMD'" class="outside-container mt-3">
  <div class="box-container">
   <div class="container">
       <div class="title">
         <div class="row">
          <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
         <div class="col-md-7 d-flex justify-content-center">Manage Users</div>
         <div class=" col-md-3 row ">
           <div class="d-flex justify-content-end">
           <button class="btn btn-outline-primary btn-sm " (click)="onAddNew()"><img src="assets/images/Add_24.png"></button>
         </div>
          </div>
        </div>
       </div>

     <div class=" row d-flex justify-content-center">
      <div class="col-md-6   d-flex justify-content-start">
      <mat-label  style="margin-left: 24px;color: rgb(151, 148, 148);">User Name</mat-label></div>
      <div class="col-md-6   d-flex justify-content-start">

      <mat-label style="color: rgb(151, 148, 148);" >User Id</mat-label></div>

     </div>
       <div class="  row d-flex justify-content-center">
        <div class="col-md-6 row">
        <!-- <mat-form-field  appearance="outline"> -->
          <div class="col-md-10   d-flex justify-content-start">
            <div class="col-md-12  flex justify-content-start">

         <p-autoComplete 
           styleClass="col-md-12 "
    [(ngModel)]="userName" 
    [dropdown]="true" 
    [suggestions]="filteredUser" 
    (completeMethod)="searchList($event)" 
    field="name">
    <ng-template let-user pTemplate="item">
      <div class="flex align-items-start " style="text-align: start;">
          
          <div>{{ user.name+' , '+ user.username }}</div>
      </div>
  </ng-template>
</p-autoComplete>
  </div>
</div>
          <!-- <input matInput type="text" name="name" autocomplete="off" [(ngModel)]="userName"> -->
        <!-- </mat-form-field> -->
        <span class="retrieve-label col-md-2">
          OR
        </span>
      </div>
        <div class=" col-md-6 row">
          <div class="col-md-9">
            <span class="col-md-12">
            <input  class="form-control" style="height: 55px;"  readonly [(ngModel)]="userName.userUid" type="text" name="useridinput" autocomplete="off">
          </span>
            <!-- <p-autoComplete styleClass="col-md-12 autoComp"
            [(ngModel)]="userName.userUid"
            [disabled]="true" 
            [dropdown]="false" 

     inputId="Userna"/> -->
      </div>

        <!-- <mat-form-field class="col-md-9" appearance="outline">
          <mat-label>User Id</mat-label>
          <input matInput readonly [(ngModel)]="userName.userUid" type="text" name="name" autocomplete="off">
        </mat-form-field> -->
        <button mat-raised-button color="accent" (click)="searchUser(userName,'button')" class=" col-md-3">
          <mat-icon>search</mat-icon> &nbsp;
          RETRIEVE
        </button>
      </div>
      </div>
   </div>
</div>
</div>
<!-- Advanced Search Box -->
<div *ngIf="showList" class="outside-container">

<div  class="box-container">
<div class="container">
 <div class="title">
  <div class="col-md-12 row">
    <div class="col-md-7 d-flex justify-content-end" >🔍  Search Users</div>
    <div class="col-md-5 d-flex justify-content-end">
      
      <mat-icon class="mt-2" style="cursor: pointer; " (click)="showSearchList()">keyboard_arrow_up</mat-icon></div>
  </div>


 </div>

<div class="col-md-12 " >
<div class="row">
<mat-form-field class=" col-md-3 mt-1 form-group " >
<input matInput type="text"     name="search" placeholder="Search..." autocomplete="off"   (input)="searchUser($event,'input')">

</mat-form-field>
<div class="col-md-2 pt-1">
  <!-- <textarea name="" id="" cols="30" rows="10" [(ngModel)]="userExcel"></textarea> -->
  <!-- <button (click)="exportData()" >exportData</button> -->
  <button  mat-raised-button color="primary" (click)="exportData()">Export Data</button>

</div>
<mat-paginator  class="col-md-7 mt-2 " style="background-color: transparent;" color="primary"
[pageSize]="10"
[pageSizeOptions]="[5, 10, 25, 100]"
[length]="totalElements"
(page)="nextPage($event)"
aria-label="Select page">
</mat-paginator>

</div>

<table mat-table
[dataSource]="dataSource" multiTemplateDataRows style="background-color: transparent;">
<ng-container matColumnDef="expand">
<th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
<td mat-cell *matCellDef="let element">
<button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
  <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
  <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
</button>
</td>
</ng-container>
<ng-container matColumnDef="id">
 <th mat-header-cell *matHeaderCellDef> Status </th>
 <td mat-cell *matCellDef="let element;"> 
  <mat-icon *ngIf="element.status==='ENABLE'" class='font-16-green-icon'>check_circle</mat-icon>
<mat-icon *ngIf="element.status==='DISABLE'" class='font-16-red-icon'>cancel</mat-icon>

<mat-icon *ngIf="element.status==='DEACTIVATED'">remove_circle</mat-icon>

  <!-- {{ element.userUid}} -->
 </td>
</ng-container>
<!-- Emp Id -->
 <ng-container matColumnDef="type">
   <th mat-header-cell *matHeaderCellDef>Type</th>
   <td mat-cell *matCellDef="let element"> {{element.userType}} </td>
 </ng-container>
<!-- Name Column -->
<ng-container matColumnDef="name">
 <th mat-header-cell *matHeaderCellDef> Name </th>
 <td mat-cell *matCellDef="let element"> {{element.name}} </td>
</ng-container>

<!-- email Column -->
<ng-container matColumnDef="email">
 <th mat-header-cell *matHeaderCellDef> Email Id </th>
 <td mat-cell *matCellDef="let element"> {{element.email}} </td>
</ng-container>
<ng-container matColumnDef="creationDate">
  <th mat-header-cell *matHeaderCellDef>Creation Date </th>
  <td mat-cell *matCellDef="let element"> {{formatDate(element.creationDate)}} </td>
 </ng-container>
 <ng-container matColumnDef="blank">
  <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
  <td mat-cell *matCellDef="let element"><button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="UpdateUser(element.email)" >
    <mat-icon>edit_note</mat-icon>
    <span>Profile</span>
  </button>
  <button *ngIf="element.userType==='CORPORATE'||element.userType==='AGENT'" mat-menu-item (click)="onConfigClick(element.userUid)" >
    <mat-icon>edit_note</mat-icon>
    <span>Config</span>
  </button>
  <button *ngIf="element.userType==='CORPORATE'||element.userType==='AGENT'" mat-menu-item (click)="onCommercialClick(element.userUid)" >
    <mat-icon>edit_note</mat-icon>
    <span>Commercials</span>
  </button>
  <button *ngIf="element.status==='ENABLE'||element.status==='DISABLE'" mat-menu-item  (click)="updateUserInfo(element)">
    <mat-icon>edit_note</mat-icon>
    <span *ngIf="element.status==='ENABLE'" >Disable</span>
    <span *ngIf="element.status==='DISABLE'" >Enable</span>

  </button>
  <button  mat-menu-item  (click)="updateDUserInfo(element)">
    <mat-icon>edit_note</mat-icon>
    <span *ngIf="element.status==='ENABLE'||element.status==='DISABLE'">Deactivate</span>
    <span *ngIf="element.status==='DEACTIVATED'">Activate</span>

    
  </button>
  <button *ngIf="element.userType==='CORPORATE'||element.userType==='STAFF'" mat-menu-item  >
    <mat-icon>edit_note</mat-icon>
    <span>Markup</span>
  </button>
  <button *ngIf="element.userType==='CORPORATE'||element.userType==='STAFF'" mat-menu-item  >
    <mat-icon>edit_note</mat-icon>
    <span>Policy</span>
  </button>
  <button *ngIf="element.userType==='CORPORATE'||element.userType==='AGENT'" (click)="onBalanceClick(element.userUid)" mat-menu-item  >
    <mat-icon>edit_note</mat-icon>
    <span>Balance</span>
  </button>
  <button  mat-menu-item (click)="EmulateUser(element)" >
    <mat-icon>edit_note</mat-icon>
    <span>Emulate</span>
  </button>
  <button *ngIf="loginUserType==='STAFF'"  mat-menu-item (click)="payment_Contract(element)" >
    <mat-icon>edit_note</mat-icon>
    <span>Payment Contract</span>
  </button>

  <button  mat-menu-item (click)="resetPasswd(element)" >
    <mat-icon>edit_note</mat-icon>
    <span>Send password Link</span>
  </button>
  
</mat-menu></td>
 </ng-container>
<!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
<ng-container matColumnDef="expandedDetail">
<td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
<div class="example-element-detail row"
 [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
 <div class=" card mt-2 mb-2 shadow">
 <div class="col-md-12 d-flex justify-content-start mt-2">
<div class="col-md-6 row">
<span class="col-md-6 bold">Email</span>
<span class="col-md-6">{{element.email ||"-"}}</span>
</div>
</div>
<div class="col-md-12 d-flex justify-content-start mt-2">
  <div class="col-md-6 row">
  <span class="col-md-6 bold">Mobile</span>
  <span class="col-md-6">{{element.mobile ||"-"}}</span>
  </div>
  </div>
  <div class="col-md-12 d-flex justify-content-start mt-2">
    <div class="col-md-6  row">
    <span class="col-md-6 bold">Creation Date</span>
    <span class="col-md-6">{{formatDate(element.creationDate) ||"-"}}</span>
    </div>
    </div>
  </div>
</div>
</td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
<tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
class="example-element-row">
</tr>
<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
<tr class="mat-row" *matNoDataRow>
<td  class="mat-cell" colspan="4">There is no data in this table</td>
</tr>
</table>


</div>
</div>
</div>
</div>
<div *ngIf="!showList&&privilegesView==='VAMD'" class="outside-container mt-2">
<div  class="box-container ">
<div class="container">
   <div class="title">
    <div class="col-md-12 row">
    <div class="col-md-7 d-flex justify-content-end" >🔍 Advanced Search</div>
    <div class="col-md-5 d-flex justify-content-end">
      <mat-icon class="mt-2" style="cursor: pointer; " (click)="showSearch()">keyboard_arrow_down</mat-icon></div>
  </div>
  </div>
   <div class="advanced-search" style="font-size: 18px">
    <div class="row">
      <mat-form-field class="col-md-4 form-group" appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select matNativeControl name="company"  [(ngModel)]="search.status">
          <mat-option value="">Any</mat-option>
          <mat-option value="ENABLE">ENABLE</mat-option>
          <mat-option value="DISABLE">DISABLE</mat-option>
          <mat-option value="DEACTIVATED">DEACTIVATED</mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-form-field class="col-md-4 form-group" appearance="outline">
        <mat-label>User Type</mat-label>
        <mat-select matNativeControl name="company" [(ngModel)]="search.userType">
          <mat-option value="">Any</mat-option>
          <mat-option value="STAFF">STAFF</mat-option>
          <mat-option value="AGENT">AGENT</mat-option>
          <mat-option value="DISTRIBUTOR">DISTRIBUTOR</mat-option>
          <mat-option value="CORPORATE">CORPORATE</mat-option>
          <mat-option value="WEB">WEB</mat-option>
          <mat-option value="SUPPLIER">SUPPLIER</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Mobile No.</mat-label>
        <input matInput type="text" name="name"  autocomplete="off" (keypress)="onlyNumberKey($event)" maxlength="14" [(ngModel)]="search.mobile">
      </mat-form-field>
      <!-- <mat-form-field class="col-md-4 form-group" appearance="outline">
        <mat-label>Group ID</mat-label>
        <mat-select matNativeControl name="groupID">
          <mat-option value="All">All</mat-option>
          <mat-option value="AUD">AUD</mat-option>
          <mat-option value="USD">USD</mat-option>
        </mat-select>
      </mat-form-field> -->
    </div>
  
    <div class="row">
     

      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
      
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>ID</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
      <mat-form-field  class="col-md-4" appearance="outline">
        <mat-label>Sales In-Charge</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
    </div>
    
    
  
    <div class="row">
      
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
      
      
  
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>External ID</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Branch Id</mat-label>
        <!-- <input matInput type="text" name="name" autocomplete="off"> -->
        <mat-select matNativeControl   name="branchid" [(ngModel)]="search.branchId">
          <mat-option  value="">-</mat-option>

          <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item?.city}}</mat-option>
      </mat-select>
      </mat-form-field>
    </div>
  
    <div  class="row">
     
          <mat-form-field *ngIf="false" class="col-md-4" appearance="outline">
            <mat-label>From</mat-label>
            <input matInput [matDatepicker]="fromDatepicker" name="fromDate" autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDatepicker></mat-datepicker>
          </mat-form-field>
      
          <mat-form-field *ngIf="false" class="col-md-4" appearance="outline">
            <mat-label>To</mat-label>
            <input matInput [matDatepicker]="toDatepicker" name="toDate" autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #toDatepicker></mat-datepicker>
          </mat-form-field>
    
  

   <div class="button-row d-flex justify-content-start mt-2">
   
    <button mat-raised-button color="primary" (click)="searchUser(userName, 'button')"> 
      <mat-icon>search</mat-icon > &nbsp;
      <span class="button-text">SEARCH</span></button>

     <button  mat-raised-button color="primary" (click)="onAddNew()">+ ADD USER</button>
     
     <button mat-raised-button color="primary"  (click)="openExcelAdd()">+ ADD USER EXCEL</button>
   
    <button mat-raised-button color="primary" >+ UPLOAD BALANCE USING EXCEL</button>
    <button mat-raised-button color="primary" (click)="synctickets()" [disabled]="disableResync" >Import Approved Users</button>

 </div>
</div>


</div>
</div>
</div></div>


                  <div class="modal" id="myModExcel" [style.display]="isexcelUpload ? 'block' : 'none'" >
                    <div class="modal-dialog" >
                        <div class="modal-content" >
                            <div class="modal-header title">
                              <h4 class="modal-title ">Add User from Excel</h4>
                              <button type="button" class="close" data-dismiss="modal" (click)="closeExcelAdd()">&times;</button>
                              </div>
                              <div class="modal-body">
                              <div class="col-md-12 mt-3" *ngIf="isexcelUpload">
                                <div class="col-md-12 d-flex justify-content-center mb-2" >
                                    <div class="col-md-12 row">                                                                      
                                      <div class="col-md-12 d-flex justify-content-center row mb-4">
                                        <section class="col-md-4 example-section">
                                          <mat-slide-toggle class="" #slideToggleUpdate [checked]="checked"  [disabled]="disabled">Update User</mat-slide-toggle>
                                          <mat-slide-toggle class="" #slideToggleNotify [checked]="checked" [disabled]="disabled"> Notification</mat-slide-toggle>

                                        </section>
                                        <div class="col-md-4">
                                          <mat-form-field class="col-md-12 form-group" appearance="outline" >
                                            <mat-label>Type</mat-label>
                                            <mat-select *ngIf="loggedInUserType!=='Corporate'" [(ngModel)]="createUserType">
                                              <mat-option value="STAFF">STAFF</mat-option>
                                              <mat-option value="CORPORATE">CORPORATE</mat-option>
                                              <mat-option value="AGENT">AGENT</mat-option>
                                              <mat-option value="DISTRIBUTOR">DISTRIBUTOR</mat-option>
                                              <mat-option value="WEB">WEB</mat-option>
                                              <mat-option value="SUPPLIER">SUPPLIER</mat-option>
                                            </mat-select>

                                            <mat-select *ngIf="loggedInUserType==='Corporate'">
                                              <mat-option value="EMPLOYEE">TRAVELLER</mat-option>                                                     
                                          </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                          <mat-form-field class="col-md-12 form-group" appearance="outline" >
                                            <mat-label>Default Status </mat-label>
                                            <mat-select [(ngModel)]="createUserStatus">
                                              <mat-option value="ENABLE">ENABLE</mat-option>
                                              <mat-option value="DISABLE">DISABLE</mat-option>
                                              </mat-select>
                                          </mat-form-field>  
                                        </div>
                                        <!-- <div class="col-md-3">                                            
                                            <div class="col-md-12">
                                              <button type="button" mat-raised-button (click)="fileInput.click()">Choose File</button>
                                              <input hidden  accept=".xlsx, .xls" (change)="onFileSelected($event)" #fileInput type="file">                        
                                            </div>                                               
                                       </div>
                                       <div *ngIf="fileSelected" class="col-md-3">                                            
                                        <div class="col-md-12">
                                           <span class="file-name">{{selectedFile?.name}}</span>
                                        </div>                                               
                                   </div> -->
                                        <!-- <section class="col-md-3 example-section">
                                          <mat-slide-toggle class="" #slideToggleNotify [checked]="checked" [disabled]="disabled"> Notification</mat-slide-toggle>
                                        </section> -->
                                      </div>
                                      <div>
                                        <p-fileUpload mode="advanced" accept=".xlsx, .xls"   [showCancelButton]="true"   [showUploadButton]="false"
                                        customUpload="true"  (onSelect)="onFileSelected($event)"></p-fileUpload>
                                        <!-- (uploadHandler)="onFileSelected($event)" -->
                                      </div>
                                      <!-- <div class="col-md-12 row mb-2 mt-2">                                        
                                             <div class="col-md-6 row mb-2">                                         
                                                    <div class="col-md-5 align=left pt-3"> Default Status </div>                              
                                                    <div class="col-md-7">
                                                        <mat-form-field class="col-md-12 form-group" appearance="outline" >
                                                          <mat-label>ENABLE </mat-label>
                                                          <mat-select [(ngModel)]="createUserStatus">
                                                            <mat-option value="ENABLE">ENABLE</mat-option>
                                                            <mat-option value="DISABLE">DISABLE</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>                                                  
                                                     </div>                                              
                                              </div>
                                              <div class="col-md-6 row mb-2">                                         
                                                <div class="col-md-3 align=left pt-3"> Type </div>                              
                                                <div class="col-md-9">
                                                    <mat-form-field class="col-md-12 form-group" appearance="outline" >
                                                      <mat-label>Type</mat-label>
                                                      <mat-select *ngIf="loggedInUserType!=='Corporate'" [(ngModel)]="createUserType">
                                                        <mat-option value="STAFF">STAFF</mat-option>
                                                        <mat-option value="CORPORATE">CORPORATE</mat-option>
                                                        <mat-option value="AGENT">AGENT</mat-option>
                                                        <mat-option value="DISTRIBUTOR">DISTRIBUTOR</mat-option>
                                                        <mat-option value="WEB">WEB</mat-option>
                                                        <mat-option value="SUPPLIER">SUPPLIER</mat-option>
                                                      </mat-select>

                                                      <mat-select *ngIf="loggedInUserType==='Corporate'">
                                                        <mat-option value="EMPLOYEE">TRAVELLER</mat-option>                                                     
                                                    </mat-select>
                                                    </mat-form-field>                                                  
                                                 </div>                                              
                                          </div>
                                      </div> -->
                                      <div class="col-md-12 row mb-2">                                      
                                     </div>                                                                                         
                                  </div>
                              </div>                                      
                              </div>
                                <div class="modal-footer">
                                  <div class="form-group form-inline ">
                                    <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                  </div>   
                                    <button class="btn btn-outline-success c-width-100px shadow " (click)="uploadUserExcelFile()" [disabled]="uploadDisable">Upload</button>
                                  <button    type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="downloadSample()">Download Sample</button>
                                  
                                </div>
                              </div>
                              </div>
                      </div>
                  </div>




                  <div class="modal" id="myMod" [style.display]="!islisthide ? 'block' : 'none'" >
                      <div class="modal-dialog" >
                          <div class="modal-content " >
                              <div class="modal-header title">
                                <h4 class="modal-title">Add User</h4>
                                <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                                </div>
                                <div class="modal-body">
                                <div class="col-md-12 mt-3 " *ngIf="!islisthide">
                                  <div class="col-md-12 d-flex justify-content-center" >
                                  <div class="col-md-12 row " >
                                      <div class=" col-md-12 ">
                                          <form  [formGroup]="userRegFg" autocomplete="off" (ngSubmit)="registerUser()" class=" row" >
                                          <mat-form-field class="col-md-12 form-group " appearance="outline">
                                            <mat-select *ngIf="loggedInUserType==='Corporate'||loggedInUserType==='EMPLOYEE'"  matNativeControl name="company"  formControlName="userType"   >
                                              <mat-option  value="EMPLOYEE" >TRAVELLER</mat-option>  
                                              <!-- <mat-option  value="AGENT" >AGENT</mat-option>                                           -->
                                            </mat-select>
                                            <mat-select *ngIf="loggedInUserType==='Agent'"  matNativeControl name="company"  formControlName="userType"   >
                                              <mat-option  value="STAFF" >STAFF</mat-option>  
                                              <!-- <mat-option  value="AGENT" >AGENT</mat-option>                                           -->
                                            </mat-select>
                                            <mat-label>User Type</mat-label>
                                            <mat-select *ngIf="loggedInUserType!='Corporate'&&loggedInUserType!='Agent'&&loggedInUserType!='EMPLOYEE'"  matNativeControl name="company"   formControlName="userType"  (selectionChange)="changeUserType()" >
                                              <mat-option  value="STAFF" >STAFF</mat-option>
                                              <mat-option  value="AGENT" >AGENT</mat-option>
                                              <mat-option  value="DISTRIBUTOR" >DISTRIBUTOR</mat-option>
                                              <mat-option  value="CORPORATE" >CORPORATE</mat-option>
                                              <mat-option  value="WEB" >WEB</mat-option>
                                              <mat-option  value="SUPPLIER" >SUPPLIER</mat-option>

                                            </mat-select>
                                            </mat-form-field>
                                                <mat-form-field class=" required col-md-12 form-group " appearance="outline">
                                                  <mat-label>Name</mat-label>
                                                  <input matInput  type="text" required maxlength="250"  formControlName="name" name="name" autocomplete="off"  >
                                                  <small *ngIf="userRegFg.controls['name'].dirty && userRegFg.controls['name'].invalid" class="warn">Please enter Name!</small>
                                                </mat-form-field>
                                              
                                                
                                                <mat-form-field class=" required col-md-12 form-group " appearance="outline">
                                                  <mat-label>Email Id</mat-label>
                                                  <input matInput  type="text" required id="inputname"  formControlName="email" name="email" autocomplete="off" (input)="verifiedEmail()" >
                                                  <small *ngIf="userRegFg.controls['email'].dirty && userRegFg.controls['email'].invalid" class="warn">Please Enter Valid Email Id!</small>
                                                  <small *ngIf="verifyEmail" class="warn"> Email Id already exists  !</small>
                                                </mat-form-field>
                                                  <mat-form-field class=" col-md-12 form-group " appearance="outline">
                                                    <mat-label>Mobile Number</mat-label>
                                                    <input matInput type="text"     formControlName="mobile" name="mobileNumber" autocomplete="off" >
                                                    <small *ngIf="userRegFg.controls['mobile'].dirty && userRegFg.controls['mobile'].invalid" class="warn">Please Enter Valid Mobile Number !</small>
                                                  </mat-form-field>   
                                                    <mat-form-field *ngIf="this.userRegFg.value.userType==='CORPORATE'" class="col-md-12 form-group " appearance="outline">
                                                     
                                                      <mat-label>Group</mat-label>
                                                      <mat-select   matNativeControl name="group"  formControlName="groupCode" >
                                                        <mat-option *ngFor="let group of groupList" [value]="group.code" >{{group.code}}</mat-option>

                                                      </mat-select>
                                                      </mat-form-field>  
                                                      <mat-form-field *ngIf="this.userRegFg.value.userType==='CORPORATE'" class="col-md-12 form-group " appearance="outline">
                                                     
                                                        <mat-label>Business Group</mat-label>
                                                        <mat-select-trigger (click)="businessGrp.open()">
                                                          <input (input)="businessGrp.open()" matInput   placeholder="Search ..." [(ngModel)]="searchBusinessQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterBusinessEntities()" />
                                                        </mat-select-trigger>
                                                        <mat-select #businessGrp="matSelect"   matNativeControl name="businessGroup"  formControlName="businessGroupCode" >
                                                          <mat-option *ngFor="let group of filteredBusinessGroup" [value]="group.code" >{{group.name}}</mat-option>
  
                                                        </mat-select>
                                                        </mat-form-field>  
                                                       <mat-form-field *ngIf="this.userRegFg.value.userType==='STAFF'" class="col-md-12 form-group " appearance="outline">
                                                     
                                                      <mat-label>Tenants</mat-label>
                                                      <mat-select   matNativeControl name="tenants"  formControlName="whitelabelId" >
                                                        <mat-option  value="0" >All</mat-option>
                                                        <mat-option *ngFor="let tenants of tenantsList" [value]="tenants.id" >{{tenants.code}}</mat-option>

                                                      </mat-select>
                                                      </mat-form-field> 
                                                     
                                                      <mat-form-field *ngIf="this.userRegFg.value.userType==='CORPORATE'||this.userRegFg.value.userType==='AGENT'" class="col-md-12 form-group " appearance="outline">
                                                        <mat-label>Branch Id</mat-label>
                                                        <mat-select    name="branchId" formControlName="branchId">
                                                          <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item?.city}}</mat-option>
                                                      </mat-select>
                                                        </mat-form-field>
                                                       
                                                        <mat-form-field  *ngIf="this.userRegFg.value.userType==='STAFF'" class="col-md-12 form-group " appearance="outline">
                                                          <mat-label>Branch Id</mat-label>
                                                          <mat-select multiple   name="branchId" formControlName="branchId">
                                                            <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item?.city}}</mat-option>
                                                        </mat-select>
                                                          </mat-form-field>    
                                                          <!-- *ngIf="userRegFg.value.userType==='STAFF'&&privilegesRolesView==='VAMD'||userRegFg.value.userType==='CORPORATE'&&privilegesRolesView==='VAMD'" -->
                                                        <mat-form-field *ngIf="loginUserType==='STAFF'&&privilegesRolesView==='VAMD'"  class="col-md-12 form-group " appearance="outline" >
                                                          <mat-label>User Role</mat-label>
                                                          <mat-select multiple    name="userRole" formControlName="roleId">
                                                           
                                                            <mat-option  *ngFor="let role of roleList" [value]="role.roleId">{{role.roleName}}</mat-option>
                                              
                                                        </mat-select>
                                                        </mat-form-field>      
                                                        <div *ngIf="this.userRegFg.value.userType==='CORPORATE'||this.userRegFg.value.userType==='AGENT'" class="col-md-12 form-group " >
                                                          <input type="checkbox" name="emailAllowed" style="cursor: pointer;margin-right: 4px;height: 15px;width: 15px;" formControlName="emailAllowed" />
                                                          <label style="color: #666666;" >Email Allowed</label>
                                                          </div> 
                                                          <div *ngIf="this.userRegFg.value.userType==='CORPORATE'||this.userRegFg.value.userType==='AGENT'" class="col-md-12 form-group mt-1" >
                                                           <input type="checkbox" name="ticket" style="cursor: pointer;margin-right: 4px;height: 15px;width: 15px;" formControlName="showTicketPricing"/>
                                                           <label style="color: #666666;">Enable Ticket Pricing</label>

                                                            </div>                                     
                                            </form>
                                      </div>
                                      </div>
                                      </div>                                      
                                </div>
                                  <div class="modal-footer">
                                    <div class="form-group form-inline ">
                                       <section class="col-md-12 d-flex justify-content-start">
                                          <mat-slide-toggle class="" #slideNotify  > Notification</mat-slide-toggle>
                                        </section>
                                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                    </div>   
                                    <button *ngIf="!disablesave" class="btn btn-outline-success c-width-100px shadow " (click)="registerUser()" [disabled]="userRegFg.invalid">Save</button>
                                      <button *ngIf="disablesave" class="btn btn-outline-success c-width-100px shadow " (click)="registerUser()" [disabled]="true">Save</button>
                                    <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                                  </div>
                                </div>
                                </div>
                        </div>
                    </div>



 